<template>
  <BaseLayout
    :championships="championships"
    :loading="loading"
    @change-championship="handleChangeChampionship"
    @click="handlerEveryClick"
  >
    <BasePage id="overview" title="Análises resumidas">
      <div class="columns is-multiline">
        <div
          v-for="(analysis, index) of overviews"
          :key="`analysis-${index}`"
          class="column is-full"
        >
          <Analysis :analysis="analysis" type="overview"></Analysis>
        </div>
      </div>
    </BasePage>
    <ModalNPSVue
      ref="nps"
      name="NPS Tela Resumo"
      text="Está gostando do Resumo?"
    ></ModalNPSVue>
  </BaseLayout>
</template>

<script>
import BaseLayout from "@/apps/Panel/layouts/BaseLayout.vue";
import BasePage from "@/apps/Panel/layouts/BasePage.vue";
import Analysis from "../../components/Overview/Analysis.vue";
import ModalNPSVue from "../../components/ModalNPS.vue";

import championshipMixins from "@/apps/Panel/mixins/championshipsMixins";
import OverviewService from "../../services/overviewService";
import Amplitude from "../../../../services/amplitude";
import { mapGetters } from "vuex";

const overviewService = new OverviewService();

export default {
  name: "Overview",
  mixins: [championshipMixins],
  components: {
    BasePage,
    BaseLayout,
    Analysis,
    ModalNPSVue,
  },
  data() {
    return {
      loading: true,
      overviews: [],
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
    amplitudeInstance() {
      const { id, email, nome, plano, expirado, limitAccess } = this.userInfo;
      return new Amplitude({ id, email, nome, plano, expirado, limitAccess });
    },
  },
  methods: {
    fetchOverview() {
      this.loading = true;
      overviewService
        .getOverview({
          region: this.getChampionship.regiao.id,
          championship: this.getChampionship.id,
        })
        .then((response) => {
          this.overviews = response;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleChangeChampionship() {
      this.fetchOverview();
    },
    handlerEveryClick() {
      const isValidated = localStorage.getItem("NPS Tela Resumo");
      if (!isValidated) {
        this.$refs.nps.handlerEveryClick();
      }
    },
  },
  async created() {
    await this.loadChampionships();
    this.fetchOverview();
  },
};
</script>

<style></style>
